import React, {useEffect, useState} from 'react';
import {FormGroup, Row} from "reactstrap";
import Col from "reactstrap/es/Col";
import Button from "reactstrap/es/Button";

const myPositionButtons = [{label: "UTG", id: "mypos_UTG"}, {label: "HIJ", id: "mypos_HIJ"}, {label: "CO", id: "mypos_CO"}, {label: "BTN", id: "mypos_BTn"},
    {label: "SB", id: "mypos_SB"}, {label: "BB", id: "mypos_BB"}];

const MyPosButtonsController = (props) => {
    const [filters, setFilters] = useState(props.filters);

    return (
        <div>
            <div style={{width: "100%"}}>
                <h5 style={{width: "100%"}} className="text-center text-white pull-left">My Position</h5>
                {/*<div className="pull-right">*/}
                {/*    <FormGroup>*/}
                {/*        <div className="custom-control custom-checkbox mt-4"*/}
                {/*        >*/}
                {/*            <input*/}
                {/*                className="custom-control-input"*/}
                {/*                id="input-reminders-cb"*/}
                {/*                type="checkbox"*/}
                {/*                onChange={e => handleORChange(e)}*/}
                {/*                checked={filters.or == true}*/}
                {/*            />*/}
                {/*            <label className="custom-control-label text-white"*/}
                {/*                   htmlFor="input-reminders-cb">*/}
                {/*                OR*/}
                {/*            </label>*/}
                {/*        </div>*/}
                {/*    </FormGroup>*/}
                {/*</div>*/}
            </div>

            {/*MY POS BUTTONS*/}
            <Row style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                {myPositionButtons.map((buttonData, index) => {
                    return (
                        <Col
                            key={index} xl={2} md={2} sm={2} lg={3} xs={2} xxl={2} style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "1px",
                            justifyContent: "center",
                            marginTop: "4px"
                        }}>
                            <Button onClick={e => props.updateFilters({myPosition: buttonData.label})} size="sm"
                                    color={filters && filters.myPosition && filters.myPosition == buttonData.label ? "warning" : "secondary"}
                                    style={{width: "100%", paddingRight: "4px", paddingLeft: "4px", paddingTop: "2px", paddingBottom: "2px"}}
                            >
                                        {buttonData.label}
                            </Button>
                        </Col>
                    )
                })}
            </Row>

            <hr className="my-4" style={{backgroundColor: "white", color: "white"}}/>

            <Row>
                <Col xl={2} md={2} sm={2} lg={3} xs={2} xxl={2} style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Button
                        disabled={!["UTG", "HIJ", "CO", "BTN", "SB"].includes(filters.myPosition)}
                        onClick={e => props.toggleOR()} size="sm" style={{width: "100%"}}
                        color={filters && filters.myPosition && filters.or == true ? "warning" : "secondary"}
                    >
                        OR
                    </Button>
            </Col>



            </Row>
        </div>
    );
};

export default MyPosButtonsController;